import memoize from 'memoize-one';
export const filterImagesByLabplanRegions = memoize((images, labPlan) => {
    if (!labPlan?.allowedRegions) {
        return [];
    }
    const allowedRegions = labPlan.allowedRegions;
    return images.filter((o) => !o.isCustomImage || o.availableRegions.some((region) => allowedRegions.includes(region)));
});
